export enum FileTypeEnum {
    Client = 1,
    Case = 2,
    Ticket =3
}
